import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {SalesErrorMessageComponent} from "./sales-error-message.component";
import {PrimengModule} from "../../shared/primeng-module/primeng.module";
import {LibraryModule} from "library";
import {SharedMessagesModule} from "projects/store/src/app/components/shared/shared-messages/shared-messages.module";
import {
  SalesErrorMessageV2Component,
  SalesErrorMessageV3Component
} from "./versions/sales-error-message-versions.component";

@NgModule({
  declarations: [
    SalesErrorMessageComponent,
    SalesErrorMessageV2Component,
    SalesErrorMessageV3Component
  ],
  imports: [
    CommonModule,
    PrimengModule,
    LibraryModule,
    SharedMessagesModule
  ],
  exports: [
    SalesErrorMessageComponent,
    SalesErrorMessageV2Component,
    SalesErrorMessageV3Component
  ]
})
export class SalesErrorMessageModule { }
